<template>
  <div
    class="relative"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <div v-if="rights.right_display" class="z-10 relative">
      <div v-if="isTaste" class="relative intro-bg">
        <rightsView.TitleView
          :titleClass="rightsView.titleClass"
          :rights="rights"
          :hovered="hovered"
        />
      </div>
      <div v-else class="relative intro-bg">
        <rightsView.TitleView
          :titleClass="rightsView.titleClass"
          :rights="rights"
          :hovered="hovered"
        />
      </div>
      <div :class="isChinese() ? 'px-[24px]' : 'px-[16px]'">
        <div
          class="flex-center flex-col"
          :class="{
            '!items-start': !isChinese(),
          }"
        >
          <!-- 价格、按钮 -->
          <rightsView.PriceView
            :rights="rights"
            :title-class="rightsView.titleClass"
          />
          <rightsView.ButtonView />
        </div>
        <div
          :class="{
            'mt-[40px]': !isChinese(),
          }"
        >
          <div v-for="(detail, index) in firstCard" :key="index">
            <div
              v-if="detail?.items?.length"
              class="text-14 text-[rgba(18,25,38,0.5)] desc-wrapper"
            >
              <div v-if="isChinese()" class="desc-title">
                {{ detail?.title }}
              </div>
              <template v-for="(item, index) in detail?.items" :key="index">
                <div
                  v-if="item?.rights_content?.[rights.rights_type]?.title"
                  class="desc-line"
                >
                  <div class="flex-1">
                    <div class="flex items-center relative">
                      <iconpark-icon
                        v-if="isChinese()"
                        :class="[
                          'mr-[4px]',
                          isTeam ? 'text-warning-7' : 'text-success-6',
                        ]"
                        size="20"
                        name="right-icon"
                      ></iconpark-icon>
                      <div
                        v-else
                        class="w-[4px] h-[4px] flex-shrink-0 mr-[8px]"
                      >
                        <div
                          class="w-[4px] h-[4px] flex-shrink-0 absolute top-[8px] rounded-full bg-[#71757D]"
                        ></div>
                      </div>
                      <div
                        v-html="item.rights_content[rights.rights_type]?.title"
                      ></div>
                      <a-popover
                        v-if="
                          detail?.idx === 0 && index === 0 && !isGlobalVersion()
                        "
                        :overlay-inner-style="{ width: '500px' }"
                        placement="right"
                        color="#ffffff"
                      >
                        <template #title>
                          <AuthorizationDifferencesContent />
                        </template>
                        <iconpark-icon
                          name="icon-circle-info"
                          class="text-text-1 ml-[4px] text-[16px] cursor-pointer"
                        />
                      </a-popover>
                      <a-tooltip
                        v-if="item.rights_content[rights.rights_type]?.hover"
                        placement="right"
                        color="#ffffff"
                      >
                        <template #title>
                          <div class="text-font-1">
                            {{ item.rights_content[rights.rights_type]?.hover }}
                          </div>
                        </template>
                        <iconpark-icon
                          name="icon-circle-info"
                          class="text-text-1 ml-[4px] text-[16px]"
                        />
                      </a-tooltip>
                    </div>
                    <div
                      v-if="item.rights_content[rights.rights_type]?.subtitle"
                      class="rights-info-subtitle text-[12px] mt-[12px] ml-[24px] flex-y-center"
                    >
                      {{ item.rights_content[rights.rights_type]?.subtitle }}
                      <a-tooltip
                        v-if="item.rights_content[rights.rights_type]?.subhover"
                        placement="right"
                        color="#ffffff"
                      >
                        <template #title>
                          <div class="text-font-1">
                            {{
                              item.rights_content[rights.rights_type]?.subhover
                            }}
                          </div>
                        </template>
                        <iconpark-icon
                          name="icon-circle-info"
                          class="text-text-1 ml-[4px] text-[16px]"
                        />
                      </a-tooltip>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getRightsView } from './rights-view'
import {
  USER_LEVEL_KEY,
  type IEquity,
  type LoginInfo,
  ORG_KEY,
} from '~/api/interface'
import { useRightsConfig } from '~/composables/rights'
import AuthorizationDifferencesContent from '~/features/paymentDesk/components/buy-rights/authorization-differences-content.vue'
import { type IRightsCompare } from '~/api/interface/rights'

const props = defineProps<{
  rights: IEquity
  accountList: LoginInfo[]
  compareRights: IRightsCompare[]
}>()

const userInfo = useUserInfo()
const overseas = useRightsConfig()

const hovered = ref(false)

const isTaste = computed(
  () => props.rights.rights_type === USER_LEVEL_KEY.TASTE
)
const isTeam = computed(
  () =>
    props.rights.rights_type === USER_LEVEL_KEY.TEAM_LIGHT ||
    props.rights.rights_type === ORG_KEY
)

// TODO 付费订阅页数据展示判断需要更改
const descInfo = computed(() => props.compareRights.filter((o) => !o.idx))

const firstCard = computed(() => {
  const first = descInfo.value[0]?.items.filter((item) => {
    return !Number(item.rights_content?.[props.rights.rights_type]?.group)
  })

  const second = descInfo.value[0]?.items.filter((item) => {
    return Number(item.rights_content?.[props.rights.rights_type]?.group) === 1
  })

  return [
    {
      ...descInfo.value[0],
      items: first,
    },
    {
      ...descInfo.value[0],
      items: second,
    },
  ]
})

// const { TitleView, PriceView, ButtonView, titleClass } = {}

const rightsView = computed(() =>
  getRightsView({
    rights: props.rights,
    userInfo: userInfo.value,
    accountList: props.accountList,
    overseas: isGlobalVersion() ? overseas.value : null,
  })
)
</script>
